module.exports = "https://static.wmbcdn.com/uniweb/images/500583d113fc20fd2025e67e77570c76.svg";